import { createFileRoute } from "@tanstack/react-router";

import AgentsAdmin from "@/components/AgentsAdmin";

// Generated to match `src/app/admin/agents/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/agents")({
  component: AgentsAdmin,
});
